const SETTINGS_KEY = 'inboxpulse_app_settings_v1';

export const DEFAULT_SETTINGS = {
  trashAutocleanEnabled: true,
  trashAutocleanDays: 30,
  /** @type {'dark' | 'light' | 'system'} */
  theme: 'dark',
  reducedMotion: false,
  analysisSensitivity: 'medium',
  maxEmailsPerBatch: 500,
  autoRefresh: false,
  soundEffects: true,
  compactResults: false,
  showAnalysisTips: true,
};

export function loadSettings() {
  try {
    const raw = localStorage.getItem(SETTINGS_KEY);
    if (!raw) return { ...DEFAULT_SETTINGS };
    const data = JSON.parse(raw);
    return {
      ...DEFAULT_SETTINGS,
      ...data,
      trashAutocleanEnabled: Boolean(data.trashAutocleanEnabled ?? DEFAULT_SETTINGS.trashAutocleanEnabled),
      trashAutocleanDays: Math.max(
        1,
        Math.min(3650, Number(data.trashAutocleanDays) || DEFAULT_SETTINGS.trashAutocleanDays)
      ),
      theme: ['dark', 'light', 'system'].includes(data.theme) ? data.theme : DEFAULT_SETTINGS.theme,
      reducedMotion: Boolean(data.reducedMotion),
      analysisSensitivity: ['low', 'medium', 'high'].includes(data.analysisSensitivity)
        ? data.analysisSensitivity
        : DEFAULT_SETTINGS.analysisSensitivity,
      maxEmailsPerBatch: Math.max(5, Math.min(500, Number(data.maxEmailsPerBatch) || DEFAULT_SETTINGS.maxEmailsPerBatch)),
      autoRefresh: Boolean(data.autoRefresh),
      soundEffects: data.soundEffects !== false,
      compactResults: Boolean(data.compactResults),
      showAnalysisTips: data.showAnalysisTips !== false,
    };
  } catch {
    return { ...DEFAULT_SETTINGS };
  }
}

export function persistSettings(partial) {
  const next = { ...loadSettings(), ...partial };
  localStorage.setItem(SETTINGS_KEY, JSON.stringify(next));
}

export function applyThemeToDocument(settings = loadSettings()) {
  const root = document.documentElement;
  let t = settings.theme || 'dark';
  if (t === 'system') {
    t = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  }
  root.dataset.theme = t;
  if (settings.reducedMotion) root.classList.add('reduce-motion');
  else root.classList.remove('reduce-motion');
}
